<script lang="ts">
	import type { RouteTrafficMentionColor$options } from '$houdini';
	import type { TrafficMentionWithGeometry } from '$lib/components/map/types';
	import {
		layout,
		SELECTED_INNER_LINE_WIDTH,
		trafficLineColor,
	} from '$lib/components/map/routePolylines/constant';
	import GeoJsonLineLayer from '$lib/components/map/routePolylines/polylines/GeoJsonLineLayer.svelte';

	interface Props {
		trafficGeometries?: TrafficMentionWithGeometry[];
	}

	const { trafficGeometries }: Props = $props();

	function getTrafficLineColor(color: RouteTrafficMentionColor$options) {
		const lowerCasedColor = color.toLowerCase() as Lowercase<RouteTrafficMentionColor$options>;
		return trafficLineColor[lowerCasedColor];
	}
</script>

{#if trafficGeometries && trafficGeometries.length > 0}
	{#each trafficGeometries as { geometry, color }, index (`${index}-${JSON.stringify(geometry.line.coordinates)}`)}
		<GeoJsonLineLayer
			{geometry}
			{layout}
			innerPaint={{
				'line-color': getTrafficLineColor(color),
				'line-width': SELECTED_INNER_LINE_WIDTH,
			}}
		/>
	{/each}
{/if}
